<main class="container-fluid">
  <div class="row">
    <div
      class="d-none d-md-block col-12 col-md-3 col-lg-3 col-xl-2 p-0 bg-primary"
      style="overflow-y: auto; min-height: 100dvh;"
    >
      <app-side-bar-desktop
        [menuData]="menu()">
      </app-side-bar-desktop>
    </div>

    <div
      class="col-12 col-md-9 col-lg-9 col-xl-10 p-0"
      style="overflow-y: auto; max-height: 100dvh;"
    >
      <div class="container-fluid h-100 bg-primary-light">
        <div class="row bg-white">
          <div class="col-12 p-0">
            <app-header
              [title]="title">
            </app-header>
          </div>

          <div class="col-12 bg-primary-light pt-4">
            <router-outlet></router-outlet>
          </div>

          <!-- TODO: add footer when needed -->
        </div>
      </div>
    </div>
  </div>
</main>

@if (sideMenuServie.showed) {
  <app-side-bar-mobile  
    [menuData]="menu()">
  </app-side-bar-mobile>
}
